import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';
import {addMessageBoxInfo} from '../../common/messageBox/actions/actions';

export const fetchVehiclesValidationList = () => apiActionCreator({
  'endpoint': '/anticipated-invoice/vehicle-validation',
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_VEHICLES_VALIDATION_LIST,
    ActionTypes.FETCHED_VEHICLES_VALIDATION_LIST,
    [ActionTypes.FETCHED_VEHICLES_VALIDATION_LIST_FAILED, (error) => buildErrorMessage(error)],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const sendVehiclesValidationNotifation = (data) =>
  apiActionCreator({
    'endpoint': '/anticipated-invoice/vehicle-notification',
    'authenticated': true,
    'types': [
      ActionTypes.SENDING_VEHICLES_VALIDATION_NOTIFICATION,
      [
        ActionTypes.SENDED_VEHICLES_VALIDATION_NOTIFICATION,
        addMessageBoxInfo('La notificación de pedido de accesorios y dispositivos fue enviada correctamente'),
      ],
      [
        ActionTypes.SENDED_VEHICLES_VALIDATION_NOTIFICATION_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'POST',
    'contentType': 'application/json',
    'data': data,
  });

export const sendVehiclesAccesoriesTransfer = (data) => (dispatch) => {
  return dispatch(apiActionCreator({
    'endpoint': '/anticipated-invoice/accessories-transfer',
    'authenticated': true,
    'types': [
      ActionTypes.SENDING_VEHICLES_ACC_TRANSFER,
      [
        () => {
          dispatch(fetchVehiclesValidationList());
          return {
            'type': ActionTypes.SENDED_VEHICLES_ACC_TRANSFER,
          };
        },
        (response) => addMessageBoxInfo('La transferencia de accesorios ha sido realizada con éxito.'),
      ],
      [
        ActionTypes.SENDED_VEHICLES_ACC_TRANSFER,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'POST',
    'contentType': 'application/json',
    'data': data,
  }));
};
